var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.plaintext)?_c('span',{staticClass:"col-form-label d-block"},[_vm._v(_vm._s(_vm.displayText))]):_c('b-form-select',_vm._g(_vm._b({attrs:{"tabindex":"0","aria-label":_vm.ariaLabel},nativeOn:{"!blur":function($event){return _vm.blurNote()}}},'b-form-select',_vm.$props,false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }